import type { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { InlineNotification, Modal, TextLink, useModalControl, Text } from '@frontend/design-system';
import { AudioQueryMedia } from '../../utils/use-audio-query';
import { PhoneTreePreviewModal } from '../common/phone-tree-dropdown/phone-tree-preview-modal';

interface VoicemailIvrNotificationProps {
  ivrMenuId?: string;
  ivrMenuName?: string;
  audioFiles?: AudioQueryMedia;
}

export const VoicemailIvrNotification: FC<VoicemailIvrNotificationProps> = ({
  ivrMenuId,
  ivrMenuName,
  audioFiles = { customMedia: [], standardMedia: [], mailboxGreetings: [], allMedia: [] },
}) => {
  const { modalProps: previewPhoneTreeModalProps, triggerProps: previewPhoneTreeTriggerProps } = useModalControl();

  return (
    <>
      <InlineNotification
        status='warn'
        size='large'
        css={css`
          max-height: unset;
          margin-bottom: ${theme.spacing(2)};
        `}
      >
        <Text size='medium'>
          You have been sending callers to a Phone Tree in this override. Voicemail Overrides will now only send callers
          to voicemail. To maintain your previous override experience, select the "Send to Phone Tree" Override type and
          select the <TextLink {...previewPhoneTreeTriggerProps}>{ivrMenuName}</TextLink> Override as the Phone Tree.
        </Text>
      </InlineNotification>

      <Modal {...previewPhoneTreeModalProps} minWidth={800} maxWidth={800}>
        <PhoneTreePreviewModal
          phoneTreeId={ivrMenuId ?? ''}
          name={ivrMenuName ?? ''}
          onClose={previewPhoneTreeModalProps.onClose}
          audioFiles={audioFiles ?? { customMedia: [], standardMedia: [], mailboxGreetings: [], allMedia: [] }}
        />
      </Modal>
    </>
  );
};
